import React from 'react';
import { connect } from 'react-redux';
import VolumeLowIcon from '@mui/icons-material/VolumeDownRounded';
import VolumeOffIcon from '@mui/icons-material/VolumeOffRounded';
import VolumeHighIcon from '@mui/icons-material/VolumeUpRounded';
import { Slider, Paper, Button, Popper, Grow } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { theme } from '../../../../../App/MuiTheme';
import { createActions } from '../../../../pages/CreatePage/store';
import { getAudioVolume, saveAudioVolume } from '../../../../../utilities/storageUtilities';
import { RealtimeAudioAnalyzer } from '../../Audio/RealtimeAudioAnalyzer';

const styles = theme => ({
    controlButton: {
        minWidth: 0,
        padding: theme.spacing(1),
        borderRadius: 100,
        color: '#fff'
    }
});

class AudioVolumeControl extends React.Component {
    state = {
        volume: getAudioVolume(),
        volumeAnchor: null,
        volumeOpen: false
    }

    render() {
        const { classes, disabled } = this.props;
        const { volume, volumeAnchor, volumeOpen } = this.state;

        return (
            <>
                <Button
                    className={classes.controlButton}
                    onClick={this.onVolumeButtonClick}
                    aria-label={(volume === 0 ? 'Unmute' : 'Mute')}
                    onMouseEnter={this.onVolumeButtonMouseEnter}
                    onMouseLeave={this.onVolumeButtonMouseLeave}
                    disabled={disabled}
                >
                    {
                        volume === 0 ? <VolumeOffIcon /> 
                        : 
                        volume < 0.5 ? <VolumeLowIcon /> : <VolumeHighIcon />
                    }
                    
                </Button>
                <Popper
                    anchorEl={volumeAnchor}
                    open={volumeOpen}
                    transition
                    onMouseEnter={this.onVolumePopperMouseEnter}
                    onMouseLeave={this.onVolumePopperMouseLeave}
                    style={{zIndex: 1}}
                >
                    {({ TransitionProps }) => (
                        <Grow {...TransitionProps} timeout={250} style={{ transformOrigin: 'bottom' }}>
                            <Paper style={{padding: theme.spacing(1)}}>
                                <Slider
                                    size='small' 
                                    orientation='vertical'
                                    value={volume}
                                    max={1}
                                    step={0.05}
                                    style={{height: 100}}
                                    onChangeCommitted={this.onVolumeSliderChangeCommitted}
                                    onChange={this.onVolumeSliderChange}
                                />
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </>
        );
    }

    onVolumePopperMouseEnter = () => {
        this.setState({volumeOpen: true});
    }

    onVolumePopperMouseLeave = () => {
        this.setState({volumeOpen: false});
    }

    onVolumeButtonMouseEnter = (e) => {
        this.setState({volumeOpen: true, volumeAnchor: e.currentTarget});
    }

    onVolumeButtonMouseLeave = (e) => {
        this.setState({volumeOpen: false, volumeAnchor: e.currentTarget});
    }

    onVolumeSliderChangeCommitted = (event, value) => {
        const { setProperty } = this.props;
        setProperty('audioMuted', value === 0);
    }

    onVolumeSliderChange = (event, value) => {
        this.setState({volume: value});
        saveAudioVolume(value);
        RealtimeAudioAnalyzer.setVolume(value);
    }

    onVolumeButtonClick = () => {
        const { volume } = this.state;
        const { setProperty } = this.props;

        if (volume === 0) {
            setProperty('audioMuted', false);
            this.setState({volume: getAudioVolume()});
            RealtimeAudioAnalyzer.setVolume(getAudioVolume());
        } else {
            setProperty('audioMuted', true);
            this.setState({volume: 0});
            RealtimeAudioAnalyzer.setVolume(0);
        }
    }
}

const mapStateToProps = (state) => {
   return {}
};

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(createActions.setProperty(key, value));

    return { setProperty }
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(AudioVolumeControl, styles));